import { connect } from 'react-redux'
import Error from './Error.jsx'
import { ackError } from 'redux/notifications/actions'
import {
    hasErrorNotification,
    getErrorNotificationMessage,
} from 'redux/notifications/selectors'

const mapStateToProps = state => ({
    hasErrorNotification : hasErrorNotification(state),
    getErrorNotificationMessage: getErrorNotificationMessage(state),
})

const mapDispatchToProps = dispatch => ({
    ack: () => dispatch(ackError()),
})

export const ErrorContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Error)
